// @ts-nocheck
import React from "react";
import { Link } from "react-router-dom";
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { DifusionIcono } from "./IconosMenu";

const itemSx = {
    mx: 0.5,
    borderRadius: 2,
    color: '#2d2d2d',
    transition: 'color 0.2s, background-color 0.2s',
    '&:hover': {
        backgroundColor: 'rgba(183, 18, 52, 0.06)',
        color: '#B71234',
    },
    '& .MuiListItemIcon-root': {
        color: 'inherit',
        minWidth: 44,
    },
};

export default function DifusionesItem({ onClick }) {
    return (
        <Link onClick={onClick} to="/difusiones/" style={{ textDecoration: 'none' }}>
            <ListItem button key="difusiones" sx={itemSx}>
                <ListItemIcon>
                    <DifusionIcono />
                </ListItemIcon>
                <ListItemText primary="Difusiones" />
            </ListItem>
        </Link>
    );
}
